var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",staticStyle:{"height":"100%","overflow-y":"scroll"}},_vm._l((_vm.inboxes),function(inbox){return _c('InboxItem',{key:inbox.id,attrs:{"inbox":inbox}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }